/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export enum SyncEvents {
  START = 'sync-start',
  PROGRESS = 'sync-progress',
  CANCEL = 'cancel',
  FINISH = 'sync-finish',
  ERROR = 'error',
}
